import type { FC } from 'react';
import { NoDataMessage } from '@/components/NoDataCard';
import Table from '@/components/UI/Table';
import type { TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';
import { renderMetadataValue } from '@/helpers';
import { _isEmpty } from '@/littledash';
import { type MetadataFieldWithValue } from '@/model/Metadata.model';

interface MetadataProps {
  metadata?: Array<MetadataFieldWithValue>;
}

const Metadata: FC<MetadataProps> = ({ metadata = [] }) => {
  const columns: Array<TanStackColumnDef<MetadataFieldWithValue>> = [
    {
      id: 'title',
      header: 'Name',
      accessorKey: 'title',
    },
    {
      id: 'value',
      header: 'Value',
      accessorKey: 'value',
      cell: ({
        row: {
          original: { field_type: fieldType, value },
        },
      }: {
        row: { original: MetadataFieldWithValue };
      }) => renderMetadataValue({ value, field_type: fieldType }),
    },
  ];

  if (_isEmpty(metadata)) {
    return <NoDataMessage title="No metadata has been entered for this study" dark />;
  } else {
    return (
      <>
        <Table data={metadata} columns={columns} />
      </>
    );
  }
};

export default Metadata;
